import { Component, Input, ElementRef } from '@angular/core';
import { encapsulation } from '../../../components/encapsulation';

@Component({
    selector: 'ubx-tabs-tab',
    templateUrl: './tabs-tab.component.html',
    host: { class: 'ubx-tabs-tab flx f-fd:c' },
    encapsulation
})
export class UBXTabsTabComponent {
    @Input() label: string;
    active: boolean;

    constructor(
        public el: ElementRef,
    ) { }
}
